














































































































































































































































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { ContractorCreate as IContractorCreate } from "@/api/models/contractor-create";
import { ContractorEdit as IContractorEdit } from "@/api/models/contractor-edit";
import { Contractor as IContractor } from "@/api/models/contractor";
import CustomInput from "@/components/form/CustomInput.vue";
import api from "@/getinfo-api";
import EditFieldInArray from "@/components/form/EditFieldInArray.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { getCurrentUserId } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, CustomInput, EditFieldInArray }
})
export default class ContractorForm extends Vue {
  @Prop() contractor?: IContractor;
  @Ref("customInputPhone") customInputPhone: any;
  @Ref("customInputEmail") customInputEmail: any;
  title!: string;
  shortTitle!: string;
  inn!: string;
  legalAddress!: string;
  factAddress!: string;
  site!: string | undefined;
  kpp!: string;
  ogrn!: string;
  paymentAccount!: string;
  correspondentAccount!: string;
  bank!: string;
  bik!: string;
  okpo!: string | undefined;
  okato!: string | undefined;
  okved!: string | undefined;
  directorName!: string;
  directorNameGenitive!: string;
  directorPosition!: string;
  basis!: string;
  phones: Array<string> = [];
  emails: Array<string> = [];
  phone!: string | undefined;
  email!: string;
  showEditEmails: boolean = false;
  isSavingProcess: boolean = false;

  data() {
    return {
      title: undefined,
      shortTitle: undefined,
      inn: undefined,
      legalAddress: undefined,
      factAddress: undefined,
      site: undefined,
      kpp: undefined,
      ogrn: undefined,
      paymentAccount: undefined,
      correspondentAccount: undefined,
      bank: undefined,
      bik: undefined,
      okpo: undefined,
      okato: undefined,
      okved: undefined,
      directorName: undefined,
      directorNameGenitive: undefined,
      directorPosition: undefined,
      basis: undefined,
      phone: undefined,
      email: undefined
    };
  }

  setPhone(item: string) {
    this.phone = item;
  }

  setEmail(item: any) {
    this.email = item;
  }

  addPhone() {
    if (this.phone && this.phone.length > 10) {
      this.phones.push(this.phone);
      this.customInputPhone.body = undefined;
      this.customInputPhone.formattedBody = undefined;
      this.phone = "";
      this.customInputPhone.state = null;
    }
  }

  deleteEmail(item: string) {
    this.emails = this.emails.filter(element => {
      return element != item;
    });
  }

  savePhones(item: any) {
    this.phones[item.index] = item.body;
  }

  deleteCustomPhone(index: number) {
    this.phones.splice(index, 1);
  }

  get userId() {
    return getCurrentUserId();
  }

  mounted() {
    this.addPhone();
    if (this.contractor) {
      this.title = this.contractor.title;
      this.shortTitle = this.contractor.shortTitle;
      this.inn = this.contractor.inn;
      this.legalAddress = this.contractor.legalAddress;
      this.factAddress = this.contractor.factAddress;
      this.site = this.contractor.site;
      this.kpp = this.contractor.kpp;
      this.ogrn = this.contractor.ogrn;
      this.paymentAccount = this.contractor.paymentAccount;
      this.correspondentAccount = this.contractor.correspondentAccount;
      this.bank = this.contractor.bank;
      this.bik = this.contractor.bik;
      this.okpo = this.contractor.okpo;
      this.okato = this.contractor.okato;
      this.okved = this.contractor.okved;
      this.directorName = this.contractor.directorName;
      this.directorNameGenitive = this.contractor.directorNameGenitive;
      this.directorPosition = this.contractor.directorPosition;
      this.basis = this.contractor.basis;
      this.phones = this.contractor.phones;
      this.emails = this.contractor.emails;
    }
  }

  saveContractor() {
    if (!this.contractor) {
      if (this.phone) {
        this.isSavingProcess = true;
        this.phones.push(this.phone);
        this.customInputPhone.body = undefined;
        this.customInputPhone.formattedBody = undefined;
        this.phone = "";
        this.customInputPhone.state = null;
      }
      if (this.email) {
        this.emails.push(this.email);
        this.email = "";
        this.customInputEmail.state = null;
        this.customInputEmail.body = undefined;
        this.customInputEmail.formattedBody = undefined;
      }
      let params: IContractorCreate = {
        userId: this.userId,
        title: this.title,
        shortTitle: this.shortTitle,
        inn: this.inn,
        legalAddress: this.legalAddress,
        factAddress: this.factAddress,
        site: this.site,
        kpp: this.kpp,
        ogrn: this.ogrn,
        paymentAccount: this.paymentAccount,
        correspondentAccount: this.correspondentAccount,
        bank: this.bank,
        bik: this.bik,
        okpo: this.okpo,
        okato: this.okato,
        okved: this.okved,
        directorName: this.directorName,
        directorNameGenitive: this.directorNameGenitive,
        directorPosition: this.directorPosition,
        basis: this.basis,
        phones: this.phones,
        emails: this.emails
      };
      api.ContractorApi.create(params)
        .then((res: { data: IContractor }) => {
          this.$router.push({
            name: "contractorItem",
            params: { contractorId: res.data.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isSavingProcess = false;
        });
    } else {
      this.isSavingProcess = true;
      let params: IContractorEdit = {
        title: this.title,
        shortTitle: this.shortTitle,
        inn: this.inn,
        legalAddress: this.legalAddress,
        factAddress: this.factAddress,
        site: this.site,
        kpp: this.kpp,
        ogrn: this.ogrn,
        paymentAccount: this.paymentAccount,
        correspondentAccount: this.correspondentAccount,
        bank: this.bank,
        bik: this.bik,
        okpo: this.okpo,
        okato: this.okato,
        okved: this.okved,
        directorName: this.directorName,
        directorNameGenitive: this.directorNameGenitive,
        directorPosition: this.directorPosition,
        basis: this.basis,
        phones: this.phones,
        emails: this.emails
      };
      api.ContractorApi.edit(this.contractor.id, params)
        .then((res: { data: IContractor }) => {
          this.$router.push({
            name: "contractorItem",
            params: { contractorId: res.data.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isSavingProcess = false;
        });
    }
  }
}
